import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: `/api/machines`,
    name: 'MACHINES_PUT',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
